import { requestMain } from "../../../apis";

export const apiGetBreakevenGameList = (params) =>
  requestMain("get", `/game/breakeven`, params, true);
